<mat-card class="no-overflow margin all">
  <mat-card-header class="shearline-header">
    <mat-card-title>Shear Line</mat-card-title>
    <div *ngIf="!editing" class="row center">
      <button
        *ngIf="
          selectedCylinder.isCrossKeyedCylinder &&
          shearLines?.shearLineDepths?.length === 0 &&
          selectedCylinder.operators?.length !== 0 &&
          selectedCylinder?.isDefaultCylinder &&
          !isGenerateShearlinesDisabled
        "
        mat-stroked-button
        (click)="generate()"
        [color]="'#393E46'"
        [outline]="false"
        [small]="true"
        class="margin left"
      >
        Generate Shear Line
      </button>
      <button
        *ngIf="selectedCylinder?.isDefaultCylinder && shearLines?.shearLineDepths?.length > 0"
        class="small-icon-button"
        (click)="toggleEdit()"
        mat-icon-button
      >
        <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
      </button>
      <button
        *ngIf="expanded && shearLines?.shearLineDepths?.length !== 0"
        class="small-icon-button"
        (click)="expanded = !expanded"
        mat-icon-button
      >
        <mat-icon fontSet="material-icons-outlined">expand_more</mat-icon>
      </button>
      <button *ngIf="!expanded" class="small-icon-button" (click)="expanded = !expanded" mat-icon-button>
        <mat-icon fontSet="material-icons-outlined">expand_less</mat-icon>
      </button>
    </div>

    <div *ngIf="editing" justify="flex-end" class="row center">
      <button mat-stroked-button (click)="cancel()" [outline]="true" [small]="true" class="margin left">Cancel</button>
      <button
        mat-stroked-button
        (click)="saveCylinder()"
        color="'#393E46'"
        [outline]="false"
        [small]="true"
        class="margin left"
      >
        Save
      </button>
    </div>
  </mat-card-header>

  <!-- Shear Line Tool Bar -->
  <div class="shearline-toolbar" *ngIf="editing">
    <div class="left">
      <div
        class="tool"
        *ngIf="isDefauldCrossKeyedCylinder() && defauldCrossKeyedCylinderHasShearlines()"
        (click)="reset()"
        [matTooltip]="'Reset to default Shear Line'"
      >
        <mat-icon>history</mat-icon>
      </div>
    </div>
    <div class="right">
      <div class="tool" (click)="sort()" [matTooltip]="'Sort Shear Line'">
        <mat-icon>swap_vert</mat-icon>
      </div>
      <div
        *ngIf="shearLines?.shearLineDepths.length > 1"
        class="tool"
        (click)="removeRow()"
        [matTooltip]="'Remove Row'"
      >
        <mat-icon>remove</mat-icon>
      </div>
      <div class="tool" (click)="addRow()" [matTooltip]="'Add Row'">
        <mat-icon>add</mat-icon>
      </div>
    </div>
  </div>

  <div class="section errors" *ngIf="shearLines?.errors?.length && editing">
    <div>
      <div class="caption error-message" *ngFor="let error of shearLines.errors">
        {{ error.errorMessage }}
      </div>
    </div>
  </div>

  <!-- Minimize -->
  <div [@fadeInOnly] *ngIf="expanded || editing">
    <!-- Disabled ShearLines -->
    <div class="row padding all" *ngIf="!editing">
      <div class="col full-width">
        <div
          class="row shearline-input-row locked-shear-line-row"
          *ngFor="let pins of shearLines?.shearLineDepths; let last = last; let rowIndex = index; trackBy: trackByFn"
        >
          <div
            [ngClass]="{
              empty: shearLines?.chambers[colIndex]?.isEmpty
            }"
            class="locked-input-wrapper"
            *ngFor="let pin of pins; let colIndex = index; trackBy: trackByFn"
          >
            <div
              class="locked-cylinder-pin"
              [@flip]="shearLines?.shearLineDepths[rowIndex][colIndex]"
              [ngClass]="{
                disabled: disabled || shearLines?.chambers[colIndex]?.isEmpty,
                warning: hasWarning(colIndex, rowIndex),
                error: hasError(colIndex, rowIndex)
              }"
            >
              {{ shearLines?.shearLineDepths[rowIndex][colIndex] }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- No ShearLines -->
    <app-nothing-here *ngIf="shearLines?.shearLineDepths?.length === 0">
      <h6>We didn't find a Shear Line for {{ selectedCylinder?.name }}.</h6>
    </app-nothing-here>

    <div class="section actions padding top bottom" *ngIf="editing">
      <!-- Label -->
      <div class="row">
        <div class="custom">
          <ng-content></ng-content>
        </div>
      </div>

      <!-- Chamber Errors -->
      <div class="row" *ngIf="shearLines?.chambers">
        <div class="checkbox-row" *ngFor="let chamber of shearLines.chambers">
          <div class="warning-icon-wrapper">
            <mat-icon
              *ngIf="chamber?.errors?.length && !chamber?.isEmpty"
              [color]="'#EE6352'"
              matTooltip="{{ condensedErrorMessages(chamber.errors) }}"
              >warning</mat-icon
            >
          </div>
        </div>
      </div>

      <!-- Inputs -->
      <div class="row" [flex]="0" *ngIf="editing && shearLines && shearLines.shearLineDepths">
        <div class="col full-width">
          <div
            class="row shear-line-row"
            *ngFor="let pins of shearLines.shearLineDepths; let last = last; let rowIndex = index; trackBy: trackByFn"
          >
            <div
              [ngClass]="{
                empty: shearLines.chambers[colIndex]?.isEmpty
              }"
              class="matrix-input-wrapper"
              *ngFor="let pin of pins; let colIndex = index; trackBy: trackByFn"
            >
              <div class="cylinder-pin">
                <input
                  arrow-div
                  (keyup)="$event.target.select()"
                  (focus)="$event.target.select()"
                  maxlength="1"
                  [ngClass]="{
                    disabled: disabled || shearLines.chambers[colIndex]?.isEmpty,
                    warning: hasWarning(colIndex, rowIndex),
                    error: hasError(colIndex, rowIndex)
                  }"
                  [disabled]="disabled || shearLines.chambers[colIndex]?.isEmpty"
                  class="matrix-input"
                  [(ngModel)]="shearLines.shearLineDepths[rowIndex][colIndex]"
                  ondragstart="return false"
                  draggable="false"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Checkboxes -->
      <div class="row" *ngIf="shearLines?.chambers">
        <div class="checkbox-row margin" *ngFor="let rule of shearLines.chambers; let chamberIndex = index">
          <div class="checkbox-wrapper">
            <mat-slide-toggle
              class="margin left"
              [checked]="!rule.isEmpty"
              [disabled]="shouldDisableToggle(chamberIndex)"
              (change)="checkBoxAction($event, rule)"
              *ngIf="shouldShowToggle(rule, chamberIndex)"
            >
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
